import React, { useState, useEffect } from "react";
import axiosConfig from "../Service/axiosConfig";
import Button from "react-bootstrap/Button";
import { useSearchParams } from "react-router-dom";
import useDebouncedValue from "../Utils/Debounce";
import CustomSelectProps from "../Components/CustomSelect/Customselect";
import { FormParser, PopupModal } from "../Components";
import DataTable from "react-data-table-component";
import { FaChevronDown } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";

const AssinedBatches = () => {
  const [options, setOptions] = useState([]); // State to hold course options
  const [batchOptions, setBatchOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || "";
  const [Error, SetError] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, SetSearch] = useState({ search: initialSearch });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const [data, setData] = useState([]);
  const [assignshow, setAssignShow] = useState(false);
  const [popupType, setpopupType] = useState("");
  const [modalType, setModalType] = useState(null);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const [formData, setFormData] = useState({
    name: "",
  });

  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);

  // Fetch courses for CustomSelect component
  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const response = await axiosConfig.get("/accounts/course/");

        const fetchedOptions = response.data?.results?.map((course) => ({
          value: course.id,
          label: course.name,
        }));
        setOptions(fetchedOptions);

        setSelectedCourseId(fetchedOptions[0]?.value);
      } catch (err) {
        SetError("Error fetching courses");
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  const handleSelectChange = (options, name) => {
    if (name === "course") {
      setSelectedOption(options);
      setSelectedCourseId(options?.value);
    } else if (name === "batch") {
      setSelectedBatchId(options?.value);
      setSelectedBatch(options);
    }
  };

  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get(
        `accounts/active_students/?course_id=${selectedOption?.value}&page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      setData(responce?.data?.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(data, "prav");

  const getBatches = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/batch/?course=${selectedOption?.value || ""}`
      );
      const fetchedOptions = response.data?.results?.map((batch) => ({
        value: batch.id,
        label: batch.name,
      }));
      setBatchOptions(fetchedOptions);
      setSelectedBatchId(fetchedOptions[0]?.value);
    } catch (err) {
      SetError("Error fetching batches");
    } finally {
      setLoading(false);
    }
  };

  const tableCustomStyles = {
    rows: {
      style: {},
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        color: "#5C5C5C",
        justifyContent: "center",
        color: "rgb(33,37,41)",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "28px",
      },
    },
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },

    {
      name: "Name",
      cell: (row) => <span>{row.student?.user?.full_name}</span>,
    },
    {
      name: "Email",
      selector: (row) => row.student?.user?.email,
      sortable: true,
    },
    {
      name: "Mobile No.",
      selector: (row) => row.student?.user?.mobileno,
      sortable: true,
    },
    {
      name: "Course",
      selector: (row) => row.course?.name,
      sortable: true,
    },
  ];

  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage, debouncedSearchTerm, selectedOption?.value]);

  // Handle row selection
  const handleRowSelected = (state) => {
    const selectedRowIds = state.selectedRows.map((row) => row.student.id);
    // const selectedcourseIds = state.selectedRows.map((row) => row.course.id);
    setSelectedStudents(selectedRowIds);
    // setSelectedCourseId(selectedcourseIds);
  };

  // Submit selected students with batch assignment
  const handleBatchAssign = () => {
    console.log(selectedStudents, selectedBatchId, selectedCourseId, "kkkk");
    if (selectedStudents.length > 0 && selectedBatchId) {
      axiosConfig
        .post("/accounts/batch-student/", {
          batch_id: selectedBatchId,
          student_ids: selectedStudents,
          course_ids: selectedCourseId,
        })
        .then((response) => {
          setMessage("Students assigned to the batch successfully");
          setpopupType("success");
          GetData();
          setAssignShow(false);
        })
        .catch((error) => {
          setMessage("Error assigning students to batch", error);
          setpopupType("error");
          let error_message = error.response?.data?.error;
          console.log(error_message);
          Object.values(error_message) &&
            SetError(Object.values(error_message));
        });
    } else {
      setMessage("Please select students and a batch");
      setpopupType("error");
    }
  };

  // Show modal and fetch batches when "Assign To" is clicked
  const handleAssignShow = () => {
    getBatches();
    setAssignShow(true);
  };

  const handleClose = () => {
    setShow(false);
    SetError("");
    setAssignShow(false);
    setpopupType("");
  };

  return (
    <div>
      <div className="course-inputs">
        <CustomSelectProps
          placeholder="Course Name"
          options={options}
          value={selectedOption}
          onChange={(option) => handleSelectChange(option, "course")}
          isSearchable
        />
      </div>
      <div className="student-table-container student-list">
        <div className="table-header new-student">
          <h1>Assign Batches</h1>
          <Button
            variant="primary"
            onClick={handleAssignShow}
            className="Add-batch"
            disabled={!selectedOption}
          >
            Assign To
          </Button>
        </div>
        <div className="custom-effective-table">
          <DataTable
            columns={columns}
            data={data}
            pagination
            fixedHeader
            fixedHeaderScrollHeight="400px"
            selectableRows
            selectableRowsHighlight
            onSelectedRowsChange={handleRowSelected} // Listen for selected rows
            sortIcon={<FaChevronDown />}
            draggableColumns
          />
        </div>
      </div>
      <Modal
        show={assignshow}
        onHide={handleClose}
        size="lg"
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="batch-header">
          <Modal.Title>Assign Batches</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomSelectProps
            placeholder="Batch Name"
            options={batchOptions}
            value={selectedBatch}
            onChange={(option) => handleSelectChange(option, "batch")}
            isSearchable
          />
          <button className="btn btn-primary mt-5" onClick={handleBatchAssign}>
            Assigned
          </button>
        </Modal.Body>
      </Modal>
      {popupType != "" && (
        <PopupModal
          setpopupType={setpopupType}
          popupType={popupType}
          Navigation=""
          error={Error}
          Message={message}
        />
      )}
    </div>
  );
};

export { AssinedBatches };
